fragment UserEmailCalendarStatusesFragment on User {
    id
    calendarSync {
        username
        isEnabled
    }
    sendableEmailAddresses {
        id
    }
    hasMailSyncEnabled
}
